import React, { useState } from 'react';
import './Join.css';

const Join = () => {
  // Google Form URLs
  const GOOGLE_FORMS = {
    volunteer: "https://forms.gle/2tKcaMfnZLpAsLwt9",
    member: "https://docs.google.com/forms/d/17kHomlWRHc64e4PI_iLXHZa8AVzjAnQdX4KWeXBA0Lg/edit"
  };

  const [selectedRole, setSelectedRole] = useState('volunteer');

  const handleRoleSelect = (role) => {
    setSelectedRole(role);
  };

  const handleJoinClick = () => {
    // Redirect to the appropriate Google Form
    window.open(GOOGLE_FORMS[selectedRole], '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="join-page">
      {/* Hero Section */}
      <section className="section hero-section">
        <div className="container">
          <h1 className="text-center">Join ClinAddis Community</h1>
          <p className="subtitle text-center">
            Be part of Ethiopia's healthcare innovation movement
          </p>
        </div>
      </section>

      {/* Join Options */}
      <section className="section">
        <div className="container">
          <div className="text-center mb-5">
            <h2>Choose How You Want to Join</h2>
            <p className="lead">Select your preferred role and click "Join Now"</p>
          </div>

          <div className="opportunities-grid">
            <div 
              className={`opportunity-card ${selectedRole === 'volunteer' ? 'selected' : ''}`}
              onClick={() => handleRoleSelect('volunteer')}
              style={{ cursor: 'pointer' }}
            >
              <div className="role-icon">🤝</div>
              <h3>Volunteer</h3>
              <p>Active contributor to ClinAddis programs and events</p>
              <ul>
                <li>Help organize events and workshops</li>
                <li>Assist with program coordination</li>
                <li>Direct impact on our initiatives</li>
              </ul>
              <div className="best-for">
                <strong>Best for:</strong> Those who want hands-on involvement
              </div>
            </div>

            <div 
              className={`opportunity-card ${selectedRole === 'member' ? 'selected' : ''}`}
              onClick={() => handleRoleSelect('member')}
              style={{ cursor: 'pointer' }}
            >
              <div className="role-icon">👥</div>
              <h3>Member</h3>
              <p>Join our network of healthcare innovators</p>
              <ul>
                <li>Access to member-only resources</li>
                <li>Priority event registration</li>
                <li>Networking opportunities</li>
                <li>Project collaboration access</li>
                <li>Regular community updates</li>
              </ul>
              <div className="best-for">
                <strong>Best for:</strong> Regular participants and supporters
              </div>
            </div>
          </div>

          {/* Join Now Button */}
          <div className="text-center mt-5">
            <button 
              onClick={handleJoinClick}
              className="submit-button"
              style={{ 
                padding: '1.2rem 3rem',
                fontSize: '1.2rem',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}
            >
              <span>Join as {selectedRole === 'volunteer' ? 'Volunteer' : 'Member'}</span>
              <span>→</span>
            </button>
            <p className="form-note mt-3">
              You will be redirected to our official Google Form to complete your application
            </p>
          </div>
        </div>
      </section>

      {/* What Volunteers Do */}
      <section className="section">
        <div className="container">
          <div className="text-center mb-5">
            <h2>What Our Volunteers Do</h2>
            <p className="lead">Volunteer opportunities at ClinAddis</p>
          </div>

          <div className="volunteer-roles">
            <div className="volunteer-role">
              <div className="role-icon">📋</div>
              <h3>Event Coordination</h3>
              <p>Help organize workshops, seminars, and the MoH Monthly Series</p>
            </div>

            <div className="volunteer-role">
              <div className="role-icon">👥</div>
              <h3>Community Engagement</h3>
              <p>Connect with students, professionals, and partner organizations</p>
            </div>

            <div className="volunteer-role">
              <div className="role-icon">💡</div>
              <h3>Program Support</h3>
              <p>Assist with Innovation Labs and Art & Medicine programs</p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
<section className="section section-alt py-6 md:py-10">
  <div className="container px-4">
    <div className="text-center mb-6">
      <h2 className="text-2xl font-bold mb-2 text-[#2c5282]">Benefits of Joining ClinAddis</h2>
      <p className="text-[#718096]">What you gain by being part of our community</p>
    </div>

    {/* Mobile: 2 columns, Desktop: 3 columns */}
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-6">
      
      {/* Card 1 */}
      <div className="bg-white rounded-lg shadow-sm p-3 md:p-5">
        <div className="text-3xl md:text-4xl mb-2">🎓</div>
        <h4 className="font-bold text-sm md:text-lg mb-1 md:mb-2 text-[#2c5282]">Learning Opportunities</h4>
        <p className="text-xs md:text-sm text-[#718096]">
          Access to workshops, seminars, and healthcare innovation resources
        </p>
      </div>

      {/* Card 2 */}
      <div className="bg-white rounded-lg shadow-sm p-3 md:p-5">
        <div className="text-3xl md:text-4xl mb-2">🤝</div>
        <h4 className="font-bold text-sm md:text-lg mb-1 md:mb-2 text-[#2c5282]">Networking</h4>
        <p className="text-xs md:text-sm text-[#718096]">
          Connect with healthcare professionals, innovators, and like-minded individuals
        </p>
      </div>

      {/* Card 3 */}
      <div className="bg-white rounded-lg shadow-sm p-3 md:p-5">
        <div className="text-3xl md:text-4xl mb-2">📜</div>
        <h4 className="font-bold text-sm md:text-lg mb-1 md:mb-2 text-[#2c5282]">Certificate</h4>
        <p className="text-xs md:text-sm text-[#718096]">
          Receive certificates of participation and completion for programs
        </p>
      </div>

      {/* Card 4 */}
      <div className="bg-white rounded-lg shadow-sm p-3 md:p-5">
        <div className="text-3xl md:text-4xl mb-2">📅</div>
        <h4 className="font-bold text-sm md:text-lg mb-1 md:mb-2 text-[#2c5282]">Event Participation</h4>
        <p className="text-xs md:text-sm text-[#718096]">
          Opportunity to partake in exclusive ClinAddis events and activities
        </p>
      </div>

      {/* Card 5 */}
      <div className="bg-white rounded-lg shadow-sm p-3 md:p-5">
        <div className="text-3xl md:text-4xl mb-2">🎯</div>
        <h4 className="font-bold text-sm md:text-lg mb-1 md:mb-2 text-[#2c5282]">Special Training</h4>
        <p className="text-xs md:text-sm text-[#718096]">
          Access to special educational and training opportunities
        </p>
      </div>

      {/* Card 6 */}
      <div className="bg-white rounded-lg shadow-sm p-3 md:p-5">
        <div className="text-3xl md:text-4xl mb-2">❤️</div>
        <h4 className="font-bold text-sm md:text-lg mb-1 md:mb-2 text-[#2c5282]">Impact</h4>
        <p className="text-xs md:text-sm text-[#718096]">
          Make a real difference in Ethiopia's healthcare innovation ecosystem
        </p>
      </div>

    </div>
  </div>
</section>

      {/* FAQ Section */}
      <section className="section">
        <div className="container">
          <div className="text-center mb-5">
            <h2>Frequently Asked Questions</h2>
          </div>

          <div className="faq-container">
            <div className="faq-item">
              <h4>Who can join ClinAddis?</h4>
              <p>We welcome medical students, healthcare professionals, researchers, innovators, artists, and anyone passionate about healthcare transformation in Ethiopia.</p>
            </div>

            <div className="faq-item">
              <h4>Can I participate remotely?</h4>
              <p>Yes! Many of our activities and meetings are hybrid, allowing both in-person and virtual participation.</p>
            </div>

            <div className="faq-item">
              <h4>Can students join?</h4>
              <p>Absolutely! Students from all disciplines are welcome and make up a significant part of our community.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="section contact-cta-section">
        <div className="container">
          <div className="text-center">
            <h2>Ready to Join Our Community?</h2>
            <p className="mb-4">Select your role above or contact us with questions</p>
            <div className="contact-cta">
              <a href="/events" className="contact-button events">
                📅 View Events
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Join; 